import { useState } from "react";
import { videoPosterUrl } from "../../utils/mediaUrls";
import "./VideoPlayer.css"

type VideoPlayerProps = {
  src: string;
  className?: string;
};

export const VideoPlayer = ({ src, className }: VideoPlayerProps) => {
  const [loading, setLoading] = useState(true);
  return (
    <>
      <video
        className={className}
        src={src}
        poster={videoPosterUrl(src)}
        autoPlay
        loop
        muted
        preload="metadata"
        onLoadedData={() => setLoading(false)}
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover", // ключевой момент
          borderRadius: "16px",
        }}
      />
      {/* {loading && (
        <div className="spinner-overlay">
          <div className="spinner" />
        </div>
      )} */}
      
    </>
  );
};

